import { render, staticRenderFns } from "./IconFillPage.vue?vue&type=template&id=7b72c739"
import script from "./IconFillPage.vue?vue&type=script&lang=js"
export * from "./IconFillPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports